// #region Imports

import * as $ from 'jquery';
import * as responsiveness from '../ui/responsiveness';
import { ScrollLock } from '../helpers/scrollLock';

// #endregion Imports

// #region Exports

export function initialize(): void {
    wireEvents();
    addEscapeKeyListener();
    addClickListener();
}

export function wireMenuLinks(): void {
    $('.js-show-left-menu').on('click', mobileExpandLeftMenu);
    $('.js-hide-left-menu').on('click', mobileContractLeftMenu);
    $('.js-toggle-left-menu').on('click', mobileToggleLeftMenu);
    $('.js-show-right-menu').on('click', mobileExpandRightMenu);
    $('.js-hide-right-menu').on('click', mobileContractRightMenu);
    $('.js-toggle-right-menu').on('click', mobileToggleRightMenu);
    $('.js-toggle-dropdown-menu').on('click', mobileToggleDdMenu);
    $('.js-toggle-document-right-menu').on('click', mobileToggleDocumentRightMenu);
    $(document).on('click', '.js-collapse-right-panel', collapseRightPanel);
}

function collapseRightPanel(event: JQuery.ClickEvent): void {
    // Under 1200px gör .innehall-toggle-btn samma sak som #document-toggler-btn
    // (öppnar/stänger #contentMobileMenu) istället för att kollapsa högerpanelen.
    // Vid >=1200px (Mode B, 1200–1460px) gäller den ursprungliga funktionen oförändrat.
    if (window.innerWidth < 1200) {
        mobileToggleDdMenu(event);
        return;
    }
    window.dispatchEvent(new Event('collapseRightPanel'));
}

// #endregion Exports

// #region Private functions

function wireEvents(): void {
    $('.js-toggle-menu').on('click', handleClick);
    $('#menubutton').on('click', handleMenuButton);
    $('#menubuttonClose').on('click', handleMenuButtonClose);
    $('#personalmenubuttonClose').on('click', handlePersonalMenuButtonClose);
    $('#documentRightMenuButton').on('click', handleDocumentRightMenu);
    wireMenuLinks();
}

function handleClick(event): void {
    event.preventDefault();

    const $target = $('#menubutton');
    const state = ($target.attr("aria-pressed") === "false");

    applyClasses(state);

    $target.attr('aria-pressed', state as any);
}

function mobileExpandLeftMenu(event): void {
    $('.content__left-column').addClass('content__left-column--open');
}

function mobileContractLeftMenu(event): void {
    $('.content__left-column').removeClass('content__left-column--open');
}

function mobileToggleLeftMenu(event): void {
    if ($('.content__left-column').hasClass('content__left-column--open')) {
        mobileContractLeftMenu();
    } else {
        mobileExpandLeftMenu();
    }
}

function mobileExpandDocumentMenu(event): void {
    $('.document-sticky__content-mobile-menu').addClass('content__mobile-dropdown--open');
    $('#document-toggler-btn').attr('aria-label', 'Stäng meny');
}

function mobileContractDocumentMenu(event): void {
    $('.document-sticky__content-mobile-menu').removeClass('content__mobile-dropdown--open');
    $('#document-toggler-btn').attr('aria-label', 'Öppna meny');
}

function relatedContractDocumentMenu(event): void {
    $('.modal-header__close').click();
}

function relatedFilterContract(): void {
    const $filterButton = $('.panel-filtrera');
    const $modalFilterButton = $('.modal-header__filter');

    if ($filterButton.attr('aria-expanded') === 'true' || $modalFilterButton.attr('aria-expanded') === 'true') {
        $filterButton.trigger('click');
        $modalFilterButton.trigger('click');
    }
}
function notesRemoveWrapperClose(): boolean {
    const $notesRemoveWrapper = $('.notifications__functions-wrapper--visible');
    const $notesRemoveButton = $('.notifications__function--close');
    if ($notesRemoveWrapper.length > 0) {
        $notesRemoveButton[0].click();
        return true;
    }

    return false;
}

function mobileToggleDdMenu(event): void {
    const isOpen = $('.document-sticky__content-mobile-menu').hasClass('content__mobile-dropdown--open');
    const $this = $(event.currentTarget);

    if (isOpen) {
        // Inuti #document-toggler-btn (rubriken "Innehåll" i den öppna menyn) ska
        // bara klick på kryss-ikonen stänga menyn – klick på "Innehåll"-texten
        // ska inte göra något. Andra triggers (t.ex. .innehall-toggle-btn) stänger
        // som förut oavsett klickmål.
        if ($this.is('#document-toggler-btn') && $(event.target).closest('.js-close-document-mobile-menu').length === 0) {
            return;
        }
        mobileContractDocumentMenu();
    } else {
        mobileExpandDocumentMenu();

        const $this = $(event.currentTarget);

        if ($this.hasClass('js-modal-focus-trap')) {
            event.stopPropagation();

            const target = "#" + $this.data('modalid');
            const $modal = $(target);

            $modal.data('trigger', $this);

            $('html').addClass('scroll-lock');

            $modal.focus();

            trapFocusAndEsc($modal[0]);
        }

    }
}

function expandDocumentRightMenu(event): void {
    $('.document-sticky__document-header-right_menu').addClass('document-sticky__document-header-right_menu--open');
}

function contractDocumentRightMenu(event): void {
    $('.document-sticky__document-header-right_menu').removeClass('document-sticky__document-header-right_menu--open');
}

function mobileToggleDocumentRightMenu(event): void {
    if ($('.document-sticky__document-header-right_menu').hasClass('document-sticky__document-header-right_menu--open')) {
        contractDocumentRightMenu();
    } else {
        expandDocumentRightMenu();
    }
}

function mobileExpandRightMenu(event): void {
    $('.content__right-column').addClass('content__right-column--open');
}

function mobileContractRightMenu(event): void {
    $('.content__right-column').removeClass('content__right-column--open');
}

function mobileToggleRightMenu(event): void {
    if($('.content__right-column').hasClass('content__right-column--open')) {
        mobileContractRightMenu();
    } else {
        mobileExpandRightMenu();
    }
}

function handleMenuButton(): void {
    const $target = $('#menubutton');
    $('#menubuttonClose').attr('aria-pressed', true);
    const state = ($target.attr("aria-pressed") !== "false");
    applyClasses(state);
}

function handleMenuButtonClose(): void {
    const $target = $('#menubuttonClose');
    $('#menubutton').attr('aria-pressed', false);
    const state = ($target.attr("aria-pressed") !== "false");
    applyClasses(state);
}

function handleDocumentRightMenu(): void {
    const $target = $('#documentRightMenuButton');
    const isActive = $target.attr("aria-pressed") === "true";
    const $parent = $target.closest('.document-sticky__document-header-right_menu');
    $parent.toggleClass('expanded', isActive);
    $(".document-sticky__document-header-right_menu .notes-show-or-hide").toggleClass("expanded", isActive);
    $(".document-sticky__document-header-right_menu .notes-show-or-hide > div").toggleClass("expanded", isActive);
    $(".document-sticky__document-header-right_menu .notes-show-or-hide .toggleSection").toggleClass("expanded", isActive);
    //$parent.toggleClass('document-sticky__document-header-right_menu--expanded', isActive);
    applyClasses(isActive);
}

function handlePersonalMenuButtonClose(): void {
    closeHeaderPressedMenus();
}

function applyClasses(state: boolean): void {
    const menu = $('.expanded-menu');

    if (state) {
        $(this).addClass("horizontal-menu__link--more-expanded");
        menu.addClass('expanded-menu--expanded');
        $('.sidebar').removeClass('sidebar--expanded');
        ScrollLock.lock();
    } else {
        menu.removeClass('expanded-menu--expanded');
        $(this).removeClass("horizontal-menu__link--more-expanded");
        ScrollLock.unlock();
    }

    $('#mobile-sidebar-trigger').removeClass('mobile-toolbar__sidebar-button--open');
}

function addEscapeKeyListener() {
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            console.log('Escape listener körs');

            if (notesRemoveWrapperClose()) {
                event.stopImmediatePropagation();
                return;
            }
            console.log('Fortsätter till menyer');

            closeExpandedMenu();
            closeHeaderPressedMenus();
            mobileContractDocumentMenu();
            relatedContractDocumentMenu();
            relatedFilterContract();
            
        }
    });
}

function addClickListener() {
    document.addEventListener('click', function (e) {
        const expandedMenu = document.querySelector('.expanded-menu.expanded-menu--expanded');
        const menuButtonState = $('#menubutton').attr('aria-pressed');
        //console.log(expandedMenu, menuButtonState, e.target);

        if (expandedMenu && !expandedMenu?.contains(e.target) && menuButtonState !== "true") {
            closeExpandedMenu();
        }
    });
}

function closeExpandedMenu() {
    $('#menubuttonClose').attr('aria-pressed', false);
    $('.expanded-menu').removeClass('expanded-menu--expanded');
    ScrollLock.unlock();
}

function closeHeaderPressedMenus() {
    $("header").find("[aria-pressed=true]").attr("aria-pressed", "false");
}

function trapFocusAndEsc(modal: HTMLElement) {

    const focusableSelectors = `
        a[href],
        button:not([disabled]),
        video[controls],
        textarea,
        input,
        select,
        [tabindex]:not([tabindex="-1"])
    `;

    const focusableElements = modal.querySelectorAll(focusableSelectors);
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    function handleKeydown(e: { key: string; shiftKey: any; preventDefault: () => void; }) {

        if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else { // Tab
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }

        if (e.key === 'Escape') {
            const closeButton = modal.querySelector('.js-close-video');
            if (closeButton) closeButton.click();
        }
    }

    modal.addEventListener('keydown', handleKeydown);
    modal._handleKeydown = handleKeydown; // spara referens för att ta bort senare
}

// #endregion Private functions
